import { render, staticRenderFns } from "./TRDA.vue?vue&type=template&id=59b1291b&scoped=true&"
import script from "./TRDA.vue?vue&type=script&lang=ts&"
export * from "./TRDA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b1291b",
  null
  
)

export default component.exports